  window.onload = function() {
    // 現在の年月の取得
    var current = new Date();
    var year = current.getFullYear();
    var month = current.getMonth() + 1;
    var day = current.getDate();
 
    // カレンダーの表示
    var wrapper = document.getElementById('calendar');
    add_calendar(wrapper, year, month);
    
}
 
/**
 * 指定した年月のカレンダーを表示する
 * @param {object} wrapper - カレンダーを追加する親要素
 * @param {number} year    - 年の指定
 * @param {number} month   - 月の指定
 */
function add_calendar(wrapper, year, month) {
    // 現在カレンダーが追加されている場合は一旦削除する
    wrapper.textContent = null;
 
    // カレンダーに表示する内容を取得
    var headData = generate_calendar_header(wrapper, year, month);
    var bodyData = generate_month_calendar(year, month, data);
 
    // カレンダーの要素を追加
    wrapper.appendChild(headData);
    wrapper.appendChild(bodyData);
}
 
/**
 * 指定した年月のカレンダーのヘッダー要素を生成して返す
 * @param {object} wrapper - カレンダーを追加する親要素
 * @param {number} year    - 年の指定
 * @param {number} month   - 月の指定
 */
function generate_calendar_header(wrapper, year, month) {
    // 前月と翌月を取得
    var nextMonth = new Date(year, (month - 1));
    nextMonth.setMonth(nextMonth.getMonth() + 1);
    var prevMonth = new Date(year, (month - 1));
    prevMonth.setMonth(prevMonth.getMonth() - 1);
 
    // ヘッダー要素
    var cHeader = document.createElement('div');
    cHeader.className = 'calendar-header';
 
    // 見出しの追加
    var cTitle = document.createElement('div');
    cTitle.className = 'calendar-header__title';
    var cTitleText = document.createTextNode(year + '年' + month + '月');
    cTitle.appendChild(cTitleText);
    cHeader.appendChild(cTitle);
 
    // 前月ボタンの追加
    var cPrev = document.createElement('button');
    cPrev.className = 'calendar-header__prev';
    var cPrevText = document.createTextNode('先月');
    cPrev.appendChild(cPrevText);
    // 前月ボタンをクリックした時のイベント設定
    cPrev.addEventListener('click', function() {
        add_calendar(wrapper, prevMonth.getFullYear(), (prevMonth.getMonth() + 1));
    }, false);
    cHeader.appendChild(cPrev);
 
    // 翌月ボタンの追加
    var cNext = document.createElement('button');
    cNext.className = 'calendar-header__next';
    var cNextText = document.createTextNode('翌月');
    cNext.appendChild(cNextText);
    // 翌月ボタンをクリックした時のイベント設定
    cNext.addEventListener('click', function() {
        add_calendar(wrapper, nextMonth.getFullYear(), (nextMonth.getMonth() + 1));
    }, false);
    cHeader.appendChild(cNext);
 
    return cHeader;
}
 
/**
 * 指定した年月のカレンダー要素を生成して返す
 * @param {number} year     - 年の指定
 * @param {number} month    - 月の指定
 * @param {object} linkData - リンクを設定する日付の情報
 */
function generate_month_calendar(year, month, linkData) {
    var weekdayData = ['日', '月', '火', '水', '木', '金', '土'];
    // カレンダーの情報を取得
    var calendarData = get_month_calendar(year, month);
 
    var i = calendarData[0]['weekday']; // 初日の曜日を取得
    // カレンダー上の初日より前を埋める
    while(i > 0) {
        i--;
        calendarData.unshift({
            day: '',
            weekday: i
        });
    }
    var i = calendarData[calendarData.length - 1]['weekday']; // 末日の曜日を取得
    // カレンダー上の末日より後を埋める
    while(i < 6) {
        i++;
        calendarData.push({
            day: '',
            weekday: i
        });
    }
 
    // カレンダーの要素を生成
    var cTable = document.createElement('table');
    cTable.className = 'calendar-table';
 
    var insertData = '';
    var display_txt = '';
    var lottery_date = '';
    var lottery_date01 = '';
    var lottery_bg01 = "";
    var lottery_date02 = '';
    var lottery_bg02 = "";
  
    // 曜日部分の生成
    insertData += '<thead>';
    insertData += '<tr>';
    for (var i = 0; i < weekdayData.length; i++) {
        insertData += '<th>';
        insertData += weekdayData[i];
        insertData += '</th>';
    }
    insertData += '</tr>';
    insertData += '</thead>';
 
    // 日付部分の生成
    insertData += '<tbody>';
    for (var i = 0; i < calendarData.length; i++) {
        if(calendarData[i]['weekday'] <= 0) {
            insertData += '<tr>';
        }
            var ymd = year + '-' + month + '-' + calendarData[i]['day'];
            var now = new Date();
            var day = now.getDate();
            insertData += '<td class="calendar-day ">';
            for (var j = 0; j < linkData.length; j++) {
               if(linkData[j]['date'] === ymd && linkData[j]['date'] != "") {
                    insertData += '<div class="js-getCalendar js-'+ ymd +'">';
                    insertData += '<span class="day">' + calendarData[i]['day'] + '</span>';
                    if(linkData[j]['event'] != 'shopify'){
                      insertData += '<div class="detail">';
                    }
                    if(linkData[j]['event'] != 'shopify'){
                      insertData += '<div class="bg01">';
                      //insertData += '<div class="icon"><img src=""></div>';
                    }else if(linkData[j]['event'] == 'BASE'){
                      insertData += '<div class="bg02">';
                      //insertData += '<div class="icon"><img src=""></div>';
                    }else if(linkData[j]['event'] == 'BASE'){
                      insertData += '<div class="bg02">';
                      //insertData += '<div class="icon"><img src=""></div>';
                    }
                    //insertData += '<a href="' + linkData[j]['link'] + '"';
                    if(linkData[j]['link']){
                      insertData += '>';
                    }
                 
                    if(linkData[j]['bg']){
                      insertData += '<p class="txt" style="background:'+ linkData[j]['bg'] + ';">'+ linkData[j]['text'] +'</p>';
                    }else{
                      insertData += '<p class="txt">'+ linkData[j]['text'] +'</p>';
                    }
                    //insertData += '</a>';
                    if(linkData[j]['event'] != ''){
                      insertData += '</div></div>';
                    }
                  
                    if(linkData[j]['lottery_date01'] != '' ){
                      var lottery_date01 = linkData[j]['lottery_date01'];
                      var lottery_text01 = linkData[j]['lottery01'];
                      var lottery_bg01 = linkData[j]['lottery_bg01'];
                      var display_txt = linkData[j]['display_txt'];
                      insertData += '<p class="lottery01 01" style="background:'+lottery_bg01+'">' + lottery_text01 + '</p>';
                    }
                   if (linkData[j-1]['lottery_date01'] == ymd){
                     insertData += '<p class="lottery01 indent" style="background:'+lottery_bg01+'">' + lottery_text01 + '</p>';
                   }

                   if(linkData[j]['lottery_date02'] != '' ){
                      var lottery_date02 = linkData[j]['lottery_date02'];
                      var lottery_text02 = linkData[j]['lottery02'];
                      var lottery_bg02 = linkData[j]['lottery_bg02'];
                      insertData += '<p class="lottery02 01" style="background:'+lottery_bg02+'">' + lottery_text02 + '</p>';
                    }
                  if (linkData[j-1]['lottery_date02'] == ymd){
                     insertData += '<p class="lottery02 indent" style="background:'+lottery_bg02+'">' + lottery_text02 + '</p>';
                   }
                    //break;
                }
                if(j >= linkData.length - 1) {
                    insertData += '<span class="day">' + calendarData[i]['day'] + '</span>';
                      if(ymd == lottery_date01){
                        if(display_txt == "on"){
                          if(linkData[j]['lottery_date01'] != '' ){
                          insertData += '<p class="lottery01" style="background:'+lottery_bg01+'">'+ lottery_text01 +'</p>';
                          }else{
                          insertData += '<p class="lottery01" style="background:'+lottery_bg01+'">　</p>';
                          }
                        }else{
                          insertData += '<p class="lottery01 indent" style="background:'+lottery_bg01+'">'+ lottery_text01 +'</p>';
                        }
                      var lottery_date01 = "";
                    }
                    if(ymd == lottery_date02){  
                      insertData += '<p class="lottery02 indent" style="background:'+lottery_bg02+'">'+ lottery_text02 +'</p>';
                      var lottery_date02 = "";
                    }
                    break;
                }
            }
        insertData += '</td>';
        if(calendarData[i]['weekday'] >= 6) {
            insertData += '</tr>';
        }
    }
    insertData += '</tbody>';
 
    cTable.innerHTML = insertData;
    return cTable;
}
 
/**
 * 指定した年月のカレンダー情報を返す
 * @param {number} year  - 年の指定
 * @param {number} month - 月の指定
 */
function get_month_calendar(year, month) {
    var firstDate = new Date(year, (month - 1), 1); // 指定した年月の初日の情報
    var lastDay = new Date(year, (firstDate.getMonth() + 1), 0).getDate(); // 指定した年月の末日
    var weekday = firstDate.getDay(); // 指定した年月の初日の曜日
 
    var calendarData = []; // カレンダーの情報を格納
    var weekdayCount = weekday; // 曜日のカウント用
    for (var i = 0; i < lastDay; i++) {
        calendarData[i] = {
            day: i + 1,
            weekday: weekdayCount
        }
        // 曜日のカウントが6(土曜日)まできたら0(日曜日)に戻す
        if(weekdayCount >= 6) {
            weekdayCount = 0;
        } else {
            weekdayCount++;
        }
    }
    return calendarData;
}

/*
window.addEventListener('load',function(){
	function menuClick(){
      // クリックした際に実行する処理を記述
    	var xhr = new XMLHttpRequest(),
    		method = "GET",
    		url = "/pages/infomation-list";//読み込まれるHTMLを指定
    	var box=document.getElementById("calendar-detail");//読み込みたい位置を指定
    
    	//xhr.responseType="document";//XMLとして扱いたいので一応記述
    	//xhr.open(method, url, true);
    	xhr.onreadystatechange = function () {
    		if(xhr.readyState === 4 && xhr.status === 200) {
    			//var restxt=xhr.responseXML;//重要
    			//var int=restxt.getElementsByClassName("js-info");//読み込まれるセレクタを指定
    			//box.innerHTML=int.outerHTML;//完了
    		}
    	};
    	//xhr.send();
	}

	// 引数に指定したclassの値をもつ要素をすべて取得
	const menus = document.getElementsByClassName('js-getCalendar');
	// 上記で取得したすべての要素に対してクリックイベントを適用
	for(let i = 0; i < menus.length; i++) {
    	menus[i].addEventListener('click', menuClick, false);
	}
});



$(window).on('load', function (){
    $(document).on('click', '.js-getCalendar', function(){
      var info_date = $(this).attr("class").replace(/js-getCalendar /g, '').replace(/js/g, '.js');
      $.ajax({
        url: "/pages/infomation-list", // 別ページにあるhtmlページURL
        cache: false,
        datatype: "html",
        success: function (html) {
          var html = $(html).find(info_date); //  別ページにあるhtml内の一部の要素を指定
          $("#calendar-detail").empty().append(html); // append関数を使って取得したhtmlコードの埋め込み先を指定
        },
      });
  });
});
*/